/* template */
<template><page><base-container><div :class='["btn-item"]'><cube-basic-picker/></div><div :class='["btn-item"]'><cube-multi-picker/></div><div :class='["btn-item"]'><cube-subtitle-picker/></div><div :class='["btn-item"]'><cube-update-data-picker/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_68b06dda"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_68b06dda"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_68b06dda"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_68b06dda"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker8d5b0acc%2Findex")),'cube-multi-picker':getComponent(require("./multi-picker.mpx?isComponent&outputPath=components%2Fmulti-picker9f1416a2%2Findex")),'cube-subtitle-picker':getComponent(require("./subtitle-picker.mpx?isComponent&outputPath=components%2Fsubtitle-pickerea17c9b8%2Findex")),'cube-update-data-picker':getComponent(require("./update-data-picker.mpx?isComponent&outputPath=components%2Fupdate-data-picker362397cc%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>